import setFullbanner from './home/1_fullbanner';
import setDepoimentos from './home/depoimentos_grande';


import setBlogPosts from './home/2_2_categories';

import setBannersLinha from './home/home_banner_linha';

import setSliderGrids from './home/4_categories';
import setQuotationVerticalSwiper from './home/3_quotation';
import setHomeProductVideos from './home/home_videos_products';
import setBlogHighlightsSwiper from './home/3_categories';
import setReviewsSwiper from './home/reviews';
import setBrandsCarousel from './home/brands_carousel';
import setIconsHorizontal from './home/horizontal_icons_slider.js';
import setIconsVertical from './home/icons_vertical';

import setProductSlider from './home/3_product_slider';
import setCarousel from '../components/carousel';
import ShopLook from './home/shop_the_look';
import CategoryTabs from './home/3_category_tabs';

import setInstagramCenter from './home/2_instagram';
import setInstagram from './home/2_instagram_section';
//addImports

import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  init: function () {
    handleConditionalLazy();

    setFullbanner()
		setDepoimentos();
		
		
		setBlogPosts();
		
		setBannersLinha();
		
		setSliderGrids();
		setQuotationVerticalSwiper();
		setHomeProductVideos.init()
		setBlogHighlightsSwiper();
		setReviewsSwiper();
		setBrandsCarousel();
		setIconsHorizontal();
		setIconsVertical();
		
		setProductSlider()
		setCarousel();
		ShopLook.init()
		CategoryTabs.init();
		
		setInstagramCenter()
		setInstagram()
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
